import React, { useContext } from 'react';
import _ from 'lodash';
import { SpaceBetweenColumn } from 'spw-shared/globalComponents/grid';
import { NO_DATA_TO_SHOW } from 'spw-constants';
import { IKeyData, IUSFTotal } from 'spw-redux/modules/program-summary/types';
import { useSelector } from 'react-redux';
import {
  selectRsfTotal,
  selectSelectedLevels,
} from 'spw-redux/modules/program-summary/esa/selectors';
import { asUsf, numberWithCommasOrDash } from 'spw-shared/utils';
import { ProgramSummaryCardsContext } from 'spw-esa-projects/program-summary/summary-cards';
import { currentProject } from 'spw-redux/modules/projects/selectors';
import { calculateLevelHeadcount } from 'spw-esa-projects/program-summary/utils';
import { HEADCOUNTS } from 'spw-redux/modules/projects/types';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import styled from 'styled-components';
import {
  BigKey,
  BigValue,
  BigValuePair,
  CardTitle,
  Card,
} from '../../../programming/program-summary/macro-single-page-summary/styles';

const KeyDataPointsCard = styled(Card)`
  flex: 1;
`;

export const KeyDataPoints = ({
  usfTotal,
  keyData,
}: {
  usfTotal: IUSFTotal;
  keyData: IKeyData;
}) => {
  const { getUnit, convertArea } = useUnitConversion();
  const { showRsf } = useContext(ProgramSummaryCardsContext);
  const project = useSelector(currentProject);
  const selectedLevels = useSelector(selectSelectedLevels);
  const { totalRsf } = useSelector(selectRsfTotal);
  const levelHeadcount = calculateLevelHeadcount(project, selectedLevels);

  return (
    <KeyDataPointsCard>
      <CardTitle style={{ marginBottom: showRsf ? '16px' : '24px' }}>
        Key Data Points
      </CardTitle>
      <SpaceBetweenColumn style={{ height: showRsf ? '213px' : '180px' }}>
        {showRsf && (
          <BigValuePair>
            <BigValue
              data-testid="key_data_points_total_building_rsf"
              warning={totalRsf < usfTotal.total}
            >
              {totalRsf && !_.isString(totalRsf) && !_.isNaN(totalRsf)
                ? asUsf(convertArea(totalRsf))
                : NO_DATA_TO_SHOW}
            </BigValue>
            <BigKey>Total {getUnit('rentable-area')}</BigKey>
          </BigValuePair>
        )}
        <BigValuePair>
          <BigValue data-testid="key_data_points_total_building_usf">
            {usfTotal.total &&
            !_.isString(usfTotal.total) &&
            !_.isNaN(usfTotal.total)
              ? asUsf(convertArea(usfTotal.total))
              : NO_DATA_TO_SHOW}
          </BigValue>
          <BigKey>Total {getUnit('area')}</BigKey>
        </BigValuePair>
        <BigValuePair>
          <BigValue data-testid="key_data_points_current_work_seats">
            {numberWithCommasOrDash(keyData?.workseats)}
          </BigValue>
          <BigKey>Work Seats</BigKey>
        </BigValuePair>
        <BigValuePair>
          <BigValue data-testid="key_data_points_current_head_count">
            {numberWithCommasOrDash(
              project.headcountType === HEADCOUNTS.ARCHITECT
                ? levelHeadcount.architectHeadcount
                : levelHeadcount.clientHeadcount
            )}
          </BigValue>
          <BigKey>Headcount</BigKey>
        </BigValuePair>
      </SpaceBetweenColumn>
    </KeyDataPointsCard>
  );
};
